interface AccountDataIconProps {
  /** Edge length in px. Defaults to 24 to match the Figma export. */
  size?: number
  className?: string
  /** Accepted for parity with `lucide-react` icons (so this component is a
   *  drop-in replacement in icon-prop slots) but ignored — the stroke widths
   *  are baked into the design. */
  strokeWidth?: number | string
}

/**
 * Branded icon for the "Konto & Daten" TopNav tab in Preferences. An
 * emerald-on-teal briefcase-with-card silhouette — intentionally warmer
 * than the neutral Lucide glyphs, so the "data & account" category reads
 * with the same playful palette as {@link AppExperienceIcon}.
 *
 * Colors are baked in (`emerald-50` fill, `teal-600` strokes) and don't
 * follow the theme palette — branded across all themes.
 *
 * @example
 * <AccountDataIcon size={24} />
 */
export function AccountDataIcon({ size = 24, className }: AccountDataIconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      aria-hidden="true"
    >
      <path
        d="M17 6H21C22.105 6 23 6.895 23 8V21C23 22.105 22.105 23 21 23H3C1.895 23 1 22.105 1 21V8C1 6.895 1.895 6 3 6H7"
        fill="#ECFDF5"
        stroke="#0D9488"
        strokeWidth="1.2"
        strokeMiterlimit="10"
        strokeLinecap="square"
      />
      <path
        d="M11 12H5V18H11V12Z"
        fill="#ECFDF5"
        stroke="#0D9488"
        strokeWidth="1.2"
        strokeMiterlimit="10"
        strokeLinecap="square"
      />
      <path
        d="M14 8H10V3C10 1.9 10.9 1 12 1C13.1 1 14 1.9 14 3V8Z"
        fill="#ECFDF5"
        stroke="#0D9488"
        strokeWidth="1.2"
        strokeMiterlimit="10"
        strokeLinecap="square"
      />
      <path
        d="M15 13H19"
        stroke="#0D9488"
        strokeWidth="1.2"
        strokeMiterlimit="10"
        strokeLinecap="square"
      />
      <path
        d="M15 17H19"
        stroke="#0D9488"
        strokeWidth="1.2"
        strokeMiterlimit="10"
        strokeLinecap="square"
      />
    </svg>
  )
}
